import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/angebot/kontaktlinsen/header.jpg"
import BildOben from "../../images/angebot/kontaktlinsen/anim.gif"
import BildUnten from "../../images/angebot/kontaktlinsen/Pentacam_70700_Optiker_201409_03_Herpes_Virus_Screen.jpg"
import Bild1 from "../../images/services/kontaktlinsen/1.jpg"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const Kontaktlinsen: React.FC = () => {
  const siteTitle = "Kontaktlinsen – Dienstleistungen"
  const greenVer = true
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle} greenVer={greenVer} background="#00aa9b">
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Kontaktlinsen"
      />
      <section className="wrapper greyColor content">
        <h1>Kontaktlinsen</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={BildOben} />
              </div>
              <div className="imageRow">
                <img src={Bild1} />
              </div>
            </div>
            <h2>Kontaktlinse oder Brille?</h2>
            <p>
              Muss keine Entweder-oder-Entscheidung sein – wir beraten Sie persönlich. Bei SCHWARZ Optik erhalten Sie nicht nur Linsen, sondern ein umfassendes Anpasskonzept.
            </p>
            <h2>Unser Gesundheitsplus</h2>
            <p>
              Als zertifizierte Gesundheitsoptiker achten wir besonders auf die regelmässige Vorsorge. Frühzeitig erkannte Sehveränderungen lassen sich mit den richtigen Linsen oft ideal ausgleichen – und langfristig kontrollieren.
            </p>
          </div>
          <div className="contentColumn">
            <h2>Kontaktlinsen – aber richtig. Die unsichtbare Sehlösung mit maximaler Individualität</h2>
            <p>
              Kontaktlinsen erfordern Know-how: Kein Auge gleicht dem anderen – jede Linse muss individuell angepasst werden. Unsere Kontaktlinsen Spezialisten speziell ausgebildet für anspruchsvolle Anpassungen und arbeiten mit modernster Messtechnik sowie neuesten Materialien. So lassen sich auch komplexe Sehfehler präzise korrigieren – ganz ohne Brille.
            </p>
            <p>
              Eine Kontaktlinse ist keine Massenware. Wir passen sie an wie ein Massanzug fürs Auge.
            </p>
            <h2>Ihre Vorteile gegenüber der Brille – Kontaktlinsen bieten:</h2>
            <ul>
              <li>uneingeschränktes Gesichtsfeld</li>
              <li>volle Bewegungsfreiheit bei Sport & Freizeit</li>
              <li>keine beschlagenen Gläser</li>
              <li>klare Sicht in jeder Situation</li>
            </ul>
            {/* TODO: Frequentlens.ch logo */}
            <h2>Kontaktlinsen bequem im Abo</h2>
            <p>Mit Frequentlens.ch kommen Ihre Linsen automatisch nach Hause – einfach, zuverlässig und portofrei.<br />
            Keine Wege, keine Umstände – dafür volle Kontrolle und persönliche Betreuung durch SCHWARZ Optik.
            </p>
            <h2>Kontaktlinsen. So bequem wie noch nie.</h2>
            {/* TODO: Bild 9803 */}
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Kontaktlinsen
